import { ProgressBar } from 'primereact/progressbar';
import { Trans, useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { useFakeProgressGenerator } from '@shared/hooks/useFakeProgressGenerator.ts';

import styles from './ApproveCampaignProgressBar.module.scss';

interface ApproveCampaignProgressBarProps {
  completed: boolean;
}

export function ApproveCampaignProgressBar({ completed }: ApproveCampaignProgressBarProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  const { formattedValue } = useFakeProgressGenerator({
    duration: 15,
    completed,
  });

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>
        <Trans t={t} i18nKey={'page.campaignDetails.campaignDetailsTab.modals.content.approveProcessingText'}>
          Your campaign is being approved on <strong>GAM</strong>. <br /> Please do not refresh / change the page.
        </Trans>
      </p>

      <ProgressBar value={formattedValue} showValue={false} />
    </div>
  );
}
